import * as Err from '@fixtuur/error-context';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import * as Api from '../../api';
import { get as _get } from '../get';
import { RequestError } from '../requestError';
import * as Url from '../../api/url';
const buildGetProductOptionsUrl = (config, groupingCode, selections) => {
    return Url.toString({
        base: config.products,
        path: `/api/v1/${encodeURIComponent(config.tenant)}/product-groups/${groupingCode}/options`,
        query: {
            selections: Api.Configuration.Selections.toString(selections),
        },
    });
};
const buildGetConfigurationSpaceOptionsUrl = (config, configurationSpaceId, selections) => {
    return Url.toString({
        base: config.compatibility,
        path: `/api/v1/${config.tenant}/options`,
        query: {
            space: configurationSpaceId,
            selections: Api.Configuration.Selections.toString(selections),
        },
    });
};
export var _GetFromProductError;
(function (_GetFromProductError) {
    _GetFromProductError["FetchError"] = "Unknown Error Fetching Response";
    _GetFromProductError["Unknown"] = "Unknown Error";
})(_GetFromProductError || (_GetFromProductError = {}));
export const getFromProductGroupingCode = (config, groupingCode, selections) => {
    return pipe(buildGetProductOptionsUrl(config, groupingCode, selections), _get, TE.mapLeft(err => {
        switch (err.message) {
            case RequestError.FetchError:
                return Err.swap(_GetFromProductError.FetchError)(err);
            default:
                return Err.swap(_GetFromProductError.Unknown)(err);
        }
    }));
};
export var _GetFromConfigurationSpaceError;
(function (_GetFromConfigurationSpaceError) {
    _GetFromConfigurationSpaceError["FetchError"] = "Unknown Error Fetching Response";
    _GetFromConfigurationSpaceError["Unknown"] = "Unknown Error";
})(_GetFromConfigurationSpaceError || (_GetFromConfigurationSpaceError = {}));
export const getFromConfigurationSpace = (config, configurationSpaceId, selections) => {
    return pipe(buildGetConfigurationSpaceOptionsUrl(config, configurationSpaceId, selections), _get, TE.mapLeft(err => {
        switch (err.message) {
            case RequestError.FetchError:
                return Err.swap(_GetFromConfigurationSpaceError.FetchError)(err);
            default:
                return Err.swap(_GetFromConfigurationSpaceError.Unknown)(err);
        }
    }));
};
